import { render } from "./ShippingAddressDetails.vue?vue&type=template&id=a38764ae"
import script from "./ShippingAddressDetails.vue?vue&type=script&lang=js"
export * from "./ShippingAddressDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__